import { render, staticRenderFns } from "./gamePage.vue?vue&type=template&id=ff14b92e&scoped=true"
import script from "./gamePage.vue?vue&type=script&lang=js"
export * from "./gamePage.vue?vue&type=script&lang=js"
import style0 from "./gamePage.vue?vue&type=style&index=0&id=ff14b92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff14b92e",
  null
  
)

export default component.exports